import { Fragment, PureComponent, ReactNode } from 'react';
import { columnHeaderContent, headerStyle } from '../../../../common/TableUtils';
import { Table } from 'antd';
import { Service } from '../../../../../api/getTreatmentPlans';
import Column from 'antd/lib/table/Column';
import { formattedNumber } from '../../../../../pages/utils';

interface Props {
    services: Service[];
}

class TreatmentServicesTable extends PureComponent<Props> {
    seqHeaderContent = columnHeaderContent('', undefined, 'whitespace-nowrap');
    servicesHeaderContent = columnHeaderContent('Services');
    toothHeaderContent = columnHeaderContent('Tooth');
    areaHeaderContent = columnHeaderContent('Area');
    qtyHeaderContent = columnHeaderContent('Qty');
    mrpHeaderContent = columnHeaderContent('Mrp');
    discountHeaderContent = columnHeaderContent('Disc. (%)', undefined, 'whitespace-nowrap');
    amountHeaderContent = columnHeaderContent('Amount');
    remarksHeaderContent = columnHeaderContent('Remarks');

    renderSeq = (_: Service, __: Service, index: number) => {
        return <p>{index + 1}</p>;
    };

    renderServices = (service: Service) => {
        const { name } = service;
        return <p>{name}</p>;
    };

    renderTooth = (service: Service) => {
        const { teeth_ids } = service;
        return <p>{teeth_ids?.join(', ') || '-'}</p>;
    };

    renderArea = (service: Service) => {
        const { surfaces } = service;
        return <p>{surfaces?.map((i) => i.name).join(', ') || '-'}</p>;
    };

    renderQty = (service: Service) => {
        const { qty } = service;
        return <p>{qty}</p>;
    };

    renderMrp = (service: Service) => {
        const { mrp } = service;
        return <p>₹{formattedNumber(mrp)}</p>;
    };

    renderDiscount = (service: Service) => {
        const { discount } = service;
        return <p>{discount}%</p>;
    };

    renderAmount = (service: Service) => {
        const { amount } = service;
        return <p>₹{formattedNumber(amount)}</p>;
    };

    renderRemarks = (service: Service) => {
        const { remarks } = service;
        return <p>{remarks || '-'}</p>;
    };

    render(): ReactNode {
        const { services } = this.props;
        const defaultHeaderStyle = headerStyle().style;
        const showColumns: { [key: string]: boolean } = {};
        services.forEach(({ teeth_ids, surfaces, discount, remarks }) => {
            if (teeth_ids && teeth_ids?.length > 0) {
                showColumns['teeth_ids'] = true;
            }
            if (surfaces && surfaces?.length > 0) {
                showColumns['surfaces'] = true;
            }
            if (discount) {
                showColumns['discount'] = true;
            }
            if (remarks) {
                showColumns['remarks'] = true;
            }
        });

        return (
            <Table
                dataSource={services}
                className="border-darwin-neutral_new-200 overflow-auto"
                pagination={false}
                bordered
                style={{
                    borderWidth: '.5px',
                }}
            >
                <Column
                    title={this.seqHeaderContent}
                    onHeaderCell={() => ({
                        style: {
                            ...defaultHeaderStyle,
                            width: '6%',
                        },
                    })}
                    key="treatment-service-row-seq"
                    render={this.renderSeq}
                />
                <Column
                    title={this.servicesHeaderContent}
                    onHeaderCell={() => ({
                        style: {
                            ...defaultHeaderStyle,
                            minWidth: '20%',
                        },
                    })}
                    key="treatment-service-row-services"
                    render={this.renderServices}
                />
                {showColumns['teeth_ids'] && (
                    <Column
                        title={this.toothHeaderContent}
                        onHeaderCell={() => ({
                            style: {
                                ...defaultHeaderStyle,
                                width: '12.5%',
                            },
                        })}
                        key="treatment-service-row-tooth"
                        render={this.renderTooth}
                    />
                )}
                {showColumns['surfaces'] && (
                    <Column
                        title={this.areaHeaderContent}
                        onHeaderCell={() => ({
                            style: {
                                ...defaultHeaderStyle,
                                width: '12.5%',
                            },
                        })}
                        key="treatment-service-row-area"
                        render={this.renderArea}
                    />
                )}
                <Column
                    title={this.qtyHeaderContent}
                    onHeaderCell={() => ({
                        style: {
                            ...defaultHeaderStyle,
                            width: '60px',
                        },
                    })}
                    key="treatment-service-row-qty"
                    render={this.renderQty}
                />
                {showColumns['discount'] && (
                    <Fragment>
                        <Column
                            title={this.mrpHeaderContent}
                            onHeaderCell={() => ({
                                style: {
                                    ...defaultHeaderStyle,
                                    width: '90px',
                                },
                            })}
                            key="treatment-service-row-mrp"
                            render={this.renderMrp}
                        />
                        <Column
                            title={this.discountHeaderContent}
                            onHeaderCell={() => ({
                                style: {
                                    ...defaultHeaderStyle,
                                    width: '70px',
                                },
                            })}
                            key="treatment-service-row-discount"
                            render={this.renderDiscount}
                        />
                    </Fragment>
                )}
                <Column
                    title={this.amountHeaderContent}
                    onHeaderCell={() => ({
                        style: {
                            ...defaultHeaderStyle,
                            width: '90px',
                        },
                    })}
                    key="treatment-service-row-amount"
                    render={this.renderAmount}
                />
                {showColumns['remarks'] && (
                    <Column
                        title={this.remarksHeaderContent}
                        onHeaderCell={() => ({
                            style: {
                                ...defaultHeaderStyle,
                                width: '15%',
                            },
                        })}
                        key="treatment-service-row-remarks"
                        render={this.renderRemarks}
                    />
                )}
            </Table>
        );
    }
}

export default TreatmentServicesTable;
